import React from 'react';

export default function OrderPriceSummary({
    subTotal,
    installationFee,
    taxRate,
    loadingTax,
    taxError,
    onClose,
    engineeringPlansFee = 0,
    installationState = '',
}) {
    const normalizedState = installationState.trim().toLowerCase();
    const isOutsideCA = normalizedState && normalizedState !== 'ca' && normalizedState !== 'california';
    const taxAmount = subTotal * (taxRate?.state_rate || 0);
    const estimatedTotal = subTotal + taxAmount + engineeringPlansFee;

    return (
        <div className="fixed bottom-8 right-8 z-[100] w-80 bg-white/95 backdrop-blur-sm p-5 rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.1)] border border-slate-100 transition-all duration-500 hover:shadow-[0_20px_60px_rgba(59,130,246,0.15)] group">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-xs font-bold text-slate-400 uppercase tracking-widest">Price Summary</h2>
                <div className="h-1.5 w-1.5 rounded-full bg-blue-500 animate-pulse"></div>
            </div>
            
            <div className="space-y-2.5 mb-5">
                <div className="flex justify-between text-sm text-slate-600">
                    <span>Subtotal</span>
                    <span className="font-semibold text-slate-900">
                        {subTotal.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                    </span>
                </div>

                {engineeringPlansFee > 0 && (
                    <div className="flex justify-between text-sm text-slate-600">
                        <span>Engineering Plans</span>
                        <span className="font-semibold text-slate-900">
                            {engineeringPlansFee.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                        </span>
                    </div>
                )}

                <div className="flex justify-between text-sm text-slate-600">
                    <span>Tax {taxRate?.state_rate ? `(${(taxRate.state_rate * 100).toFixed(2)}%)` : ''}</span>
                    <span className="font-semibold text-slate-900">
                        {loadingTax ? (
                            <span className="text-slate-400 italic text-xs">Calculating...</span>
                        ) : (
                            taxAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                        )}
                    </span>
                </div>
                {taxError && <p className="text-[10px] text-red-500 text-right mt-0.5">Error calculating tax</p>}
            </div>

            <div className="border-t border-slate-50 pt-4 mb-5">
                <div className="flex justify-between items-center">
                    <span className="font-bold text-slate-800 text-sm">Est. Total</span>
                    <span className="text-xl font-black text-blue-600">
                        {estimatedTotal.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                    </span>
                </div>
            </div>

            {isOutsideCA && (
                <div className="mb-3 p-2.5 bg-amber-50 border border-amber-200 rounded-xl flex items-start gap-2">
                    <span className="text-amber-500 text-sm mt-0.5">⚠</span>
                    <p className="text-amber-700 text-[10px] font-semibold leading-snug">
                        Please double check the prices outside of California before submitting the quote.
                    </p>
                </div>
            )}
            <button
                type="button"
                onClick={onClose}
                className="w-full py-2.5 rounded-xl border border-slate-100 text-slate-400 text-xs font-bold hover:bg-red-50 hover:text-red-500 hover:border-red-100 transition-all duration-300"
            >
                Cancel Quote
            </button>
        </div>
    );
}
